module.exports = __webpack_public_path__ + "static/media/goblin_swordman_circle.4d8aa063.svg";